import ENV from 'config/env';
export function getLanguage() {
    var localStorageLanguage = localStorage.getItem('LANGUAGE');
    if (!localStorageLanguage || (localStorageLanguage === null || localStorageLanguage === void 0 ? void 0 : localStorageLanguage.length) !== 5) {
        return ENV.DEFAULT_LANGUAGE;
    }
    return localStorageLanguage;
}
